import { type Money, formatMoney } from '@betterment/core';
import { HStack, Text, VStack } from '@betterment/samba-react';

import { type MarketScheduleType, nextMarketOpenAtLabelForClosedMarket } from '../../marketSchedule';

type ClosedMarketHoursType = {
  currentDate: Date;
  latestPriceAmount: Money;
  marketSchedule: MarketScheduleType;
};

export const ClosedMarketHours = ({ currentDate, latestPriceAmount, marketSchedule }: ClosedMarketHoursType) => {
  const { hasNextMarketOpenLabel, nextMarketOpenLabel } = nextMarketOpenAtLabelForClosedMarket({
    currentDate,
    marketSchedule,
  });

  return (
    <VStack>
      <Text color="text" variant="text100">
        Last price
      </Text>
      <Text variant="text400">{formatMoney(latestPriceAmount, 'default')}</Text>
      <HStack css={{ gap: 'space.50', alignItems: 'center' }}>
        {hasNextMarketOpenLabel && (
          <Text variant="text100" color="text.weak">
            {nextMarketOpenLabel}
          </Text>
        )}
      </HStack>
    </VStack>
  );
};
